import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
import jobPartiesMixin from './jobPartiesMixin'
import { cancelDoneJob, doneJob } from '@/api/jobs/job/job'
import { STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import { RootState } from '@/store'
import notifiableRequest from '@/utils-ts/notifiableRequest'

export default Vue.extend({
  mixins: [jobPartiesMixin],
  data() {
    return {
      donning: false,
      cancelDone: false,
    }
  },
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
    }),
    hasJobDone() {
      return this.isWorker && !this.application.job?.isDone && this.application.job.stage === STAGE_IN_PROGRESS
    },
    hasJobWasDone() {
      return this.application.job?.isDone && this.application.job.stage === STAGE_IN_PROGRESS
    },
  },
  methods: {
    ...mapMutations({
      setJobIsDone: 'jobChat/setJobIsDone',
    }),
    async markJobAsDone() {
      this.donning = true
      try {
        await notifiableRequest({
          request: async () => {
            await doneJob(this.application.job.id)
            this.setJobIsDone({ id: this.application.id, isDone: true })
          },
          title: 'Completing job',
          successText: 'You have marked this Job as complete.',
          failureText: 'Error submitting request. Please try again.',
        })
      } finally {
        this.donning = false
      }
    },
    async markJobAsNotDone() {
      this.cancelDone = true
      try {
        await notifiableRequest({
          request: async () => {
            await cancelDoneJob(this.application.job.id)
            this.setJobIsDone({ id: this.application.id, isDone: false })
          },
          title: 'Completing job',
          successText: 'Job marked as incomplete.',
          failureText: 'Error submitting request. Please try again.',
        })
      } finally {
        this.cancelDone = false
      }
    },
  },
})
